export const selectLocalVideoProducer = (
  producers = {},
  screenShareEnabled = false,
) => {
  const videoProducers = Object.values(producers).filter(
    producer => producer.track && producer.track.kind === 'video',
  );

  const preferredType = screenShareEnabled ? 'share' : 'webcam';
  const preferredProducer = videoProducers.find(
    producer => producer.type === preferredType,
  );

  return (
    (isRenderableLocalVideoProducer(preferredProducer)
      ? preferredProducer
      : videoProducers.find(isRenderableLocalVideoProducer)) ||
    preferredProducer ||
    videoProducers[0]
  );
};

export const isRenderableLocalVideoProducer = producer =>
  Boolean(
    producer &&
      !producer.paused &&
      producer.track &&
      producer.track.kind === 'video' &&
      producer.track.readyState !== 'ended',
  );

export const getLocalVideoObjectFit = producer =>
  producer && producer.type === 'share' ? 'contain' : 'cover';
